import { avatarInitials, avatarSlotFor } from '../../../lib/avatar-color';
import { Avatar } from '../../symphony/ui/Avatar';

/**
 * A referral's avatar (Figma 5339-2840), shared by both web share layouts. Nothing here but the
 * referral's reading of the shared `Avatar`: the circle, the ramp slot and the initials' type scale all
 * come from the DS primitive, so a referral row and a connector account row cannot disagree about what a
 * person looks like.
 *
 * `anonymous` drops the initials — the referral list no longer carries a name, and initials derived from
 * an opaque id would be meaningless letters dressed up as a person. What remains is the bare ramp slot,
 * still seeded from `name` (the referral id there) so each row keeps a stable identity. Deliberately the
 * same treatment on iOS and Android: a tinted circle, no glyph.
 */
export function ReferralAvatar({ name, size = 40, anonymous = false }: { name: string; size?: number; anonymous?: boolean }) {
  return <Avatar initials={anonymous ? '' : avatarInitials(name)} size={size} color={avatarSlotFor(name)} />;
}
